
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hpb",
      function () {
        return require("private-next-pages/hpb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hpb"])
      });
    }
  